<div class="right-side p-5">
  <h2>IA Grading Report</h2>
  <div class="section">
    <form [formGroup]="frmGrading">
      <div class="row">
        <div class="text-end">
          <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2"><i class="bi bi-file-earmark-excel"></i> Export To Excel</button>
          <button (click)="exportToPDF()" type="button" class="btn btn-sm btn-primary">Export to PDF</button>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>Intervention Name</mat-label>
            <mat-select formControlName="intervention" (selectionChange)="GetComponent($event)">
              <mat-option *ngFor="let In of Intervention_help" [value]="In.id">
                {{ In.text }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>Component Name</mat-label>
            <mat-select formControlName="interest">
              <mat-option *ngFor="let In of Component_help" [value]="In.id">
                {{ In.text }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-lg-1">
          <button class="btn btn-outline-secondary search-button mt-3 p-2 me-2" type="submit" (click)="onSearchClick(frmGrading.get('searchControl')?.value ?? '')" id="btnSearch">
            <i class="bi bi-search fs-4"></i>
          </button>
          <button class="btn btn-outline-secondary mt-3 p-2" type="reset" (click)="resetPage()" id="btnReset">
            <i class="bi bi-arrow-clockwise fs-4"></i>
          </button>
        </div>
      </div>
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="table table-striped table-bordered table-hover" matTableResponsive
               matSortActive="starRating" matSortDirection="desc" matSortDisableClear>
          <ng-container matColumnDef="rowNum">
            <th mat-header-cell *matHeaderCellDef>Sr.No</th>
            <td mat-cell *matCellDef="let el"> {{el.rowNum}} </td>
          </ng-container>
          <ng-container matColumnDef="nameOfOrganisation">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let el"> {{el.nameOfOrganisation}} </td>
          </ng-container>
          <ng-container matColumnDef="iaUserName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
            <td mat-cell *matCellDef="let el"> {{el.iaUserName}} </td>
          </ng-container>
          <ng-container matColumnDef="interventionName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Intervention Name</th>
            <td mat-cell *matCellDef="let el"> {{el.interventionName}} </td>
          </ng-container>
          <ng-container matColumnDef="interestName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Interest Name</th>
            <td mat-cell *matCellDef="let el"> {{el.interestName}} </td>
          </ng-container>
          <ng-container matColumnDef="latestEventDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Latest Event Date</th>
            <td mat-cell *matCellDef="let el"> {{el.latestEventDate}} </td>
          </ng-container>
          <ng-container matColumnDef="totalEventCount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Completed</th>
            <td mat-cell *matCellDef="let el" class="clickable-cell" (click)="onViewEvent(eventPopup, el.industryAssociationId)" style="cursor: pointer;">
              <span class="text-primary no-underline">
                {{el.totalEventCount}}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="createdBy">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Feedback Count</th>
            <td mat-cell *matCellDef="let el" class="clickable-cell" (click)="onViewFeedback(feedbackPopup, el.industryAssociationId)" style="cursor: pointer;">
              <span class="text-primary no-underline">
                {{el.createdBy}}
              </span>
            </td>
          </ng-container>         
          <ng-container matColumnDef="starRating">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Star Rating</th>
            <td mat-cell *matCellDef="let el">
              <div class="stars-container" matTooltip="{{ el.starRating }}" matTooltipPosition="above">
                <div *ngFor="let star of stars; let i = index">
                  <i *ngIf="getStarType(i, el.starRating) === 'full'" class="bi bi-star-fill text-warning"></i>
                  <i *ngIf="getStarType(i, el.starRating) === 'half'" class="bi bi-star-half text-warning"></i>
                  <i *ngIf="getStarType(i, el.starRating) === 'empty'" class="bi bi-star text-warning"></i>
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          Row shown when there is no matching data.
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No data matching the filter</td>
          </tr>
        </table>
      </div>
      <mat-paginator #paginator
                     class="demo-paginator"
                     (page)="onPageChange($event)"
                     [length]="length"
                     [pageSize]="pageSize"
                     [showFirstLastButtons]="showFirstLastButtons"
                     [pageSizeOptions]="pageSizeOptions"
                     [hidePageSize]="hidePageSize"
                     [pageIndex]="pageIndex"
                     aria-label="Select page">
      </mat-paginator>

      <ng-template #eventPopup class="dialog-container" fxLayout="column" fxFill>
        <h1 mat-dialog-title>Event List</h1>
        <div mat-dialog-content>
          <div class="row mb-1">
            <div class="col-md-12">
              <div class="table-responsive">
                <table mat-table [dataSource]="dataSourceGradingEvent" matSort class="table table-striped table-bordered table-hover" matTableResponsive matSortActive="eventId" matSortDirection="asc" matSortDisableClear>
                  <ng-container matColumnDef="Sr.No">
                    <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
                    <td mat-cell *matCellDef="let el"> {{el.rowNum}} </td>
                  </ng-container>
                  <ng-container matColumnDef="eventId">
                    <th mat-header-cell *matHeaderCellDef>Event Id</th>
                    <td mat-cell *matCellDef="let el"> {{el.eventId}} </td>
                  </ng-container>
                  <ng-container matColumnDef="eventName">
                    <th mat-header-cell *matHeaderCellDef>Event Name</th>
                    <td mat-cell *matCellDef="let el"> {{el.eventName}} </td>
                  </ng-container>
                  <ng-container matColumnDef="totalEnrolledMSME">
                    <th mat-header-cell *matHeaderCellDef>Enrolled MSME</th>
                    <td mat-cell *matCellDef="let el" class="clickable-cell" (click)="onViewEnrolled(enrolledPopup, el.uniqueEventId)" style="cursor: pointer;">
                      <span class="text-primary no-underline">
                        {{el.totalEnrolledMSME}}
                      </span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="totalAttendedMSME">
                    <th mat-header-cell *matHeaderCellDef>Attended MSME</th>
                    <td mat-cell *matCellDef="let el" class="clickable-cell" (click)="onViewAttended(attendedPopup, el.uniqueEventId)" style="cursor: pointer;">
                      <span class="text-primary no-underline">
                        {{el.totalAttendedMSME}}
                      </span>
                    </td>
                    <!--<td mat-cell *matCellDef="let el"> {{el.totalAttendedMSME}} </td>-->
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedEventColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedEventColumns;"></tr>
                  Row shown when there is no matching data.
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No data matching the filter</td>
                  </tr>
                </table>
              </div>
              <mat-paginator #paginator
                             class="demo-paginator"
                             (page)="onPageEventChange($event)"
                             [length]="eventLength"
                             [pageSize]="eventPageSize"
                             [showFirstLastButtons]="eventShowFirstLastButtons"
                             [pageSizeOptions]="eventPageSizeOptions"
                             [hidePageSize]="eventHidePageSize"
                             [pageIndex]="eventPageIndex"
                             aria-label="Select page">

              </mat-paginator>
            </div>
          </div>
          <div class="row">
            <div mat-dialog-actions class="action-buttons">
              <button mat-button mat-dialog-close (click)="onClosePopup()">Close</button>
            </div>
          </div>
        </div>
      </ng-template>
      <!--Enrolled List Grid-->
      <ng-template #enrolledPopup>
        <h1 mat-dialog-title>Enrolled List</h1>
        <div mat-dialog-content>
          <div class="row mb-1">
            <div class="col-md-12">
              <div class="table-responsive">
                <table mat-table [dataSource]="dataSourceEnrolled" matSort class="table table-striped table-bordered table-hover" matTableResponsive matSortActive="eventId" matSortDirection="asc" matSortDisableClear>
                  <ng-container matColumnDef="Sr.No">
                    <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
                    <td mat-cell *matCellDef="let el"> {{el.serialNumber}} </td>
                  </ng-container>
                  <ng-container matColumnDef="eventId">
                    <th mat-header-cell *matHeaderCellDef>Event Id</th>
                    <td mat-cell *matCellDef="let el"> {{el.eventId}} </td>
                  </ng-container>
                  <ng-container matColumnDef="udyamNumber">
                    <th mat-header-cell *matHeaderCellDef>Udyam Number</th>
                    <td mat-cell *matCellDef="let el"> {{el.udyamNumber}} </td>
                  </ng-container>
                  <ng-container matColumnDef="nameOfEnterprise">
                    <th mat-header-cell *matHeaderCellDef>Enterprise Name</th>
                    <td mat-cell *matCellDef="let el"> {{el.nameOfEnterprise}} </td>
                  </ng-container>
                  <ng-container matColumnDef="participantName">
                    <th mat-header-cell *matHeaderCellDef>Participant Name</th>
                    <td mat-cell *matCellDef="let el"> {{el.participantName}} </td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let el"> {{el.status}} </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedEnrolledColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedEnrolledColumns;"></tr>
                  Row shown when there is no matching data.
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No data matching the filter</td>
                  </tr>
                </table>
              </div>
              <mat-paginator #paginator
                             class="demo-paginator"
                             (page)="onPageEnrolledChange($event)"
                             [length]="enrolledLength"
                             [pageSize]="enrolledPageSize"
                             [showFirstLastButtons]="enrolledShowFirstLastButtons"
                             [pageSizeOptions]="enrolledPageSizeOptions"
                             [hidePageSize]="enrolledHidePageSize"
                             [pageIndex]="enrolledPageIndex"
                             aria-label="Select page">
              </mat-paginator>
            </div>
          </div>
          <div class="row">
            <div mat-dialog-actions class="action-buttons">
              <button mat-button mat-dialog-close (click)="onClosePopup()">Close</button>
            </div>
          </div>
        </div>
      </ng-template>
      <!--Attended List Grid-->
      <ng-template #attendedPopup>
        <h1 mat-dialog-title>Attended List</h1>
        <div mat-dialog-content>
          <div class="row mb-1">
            <div class="col-md-12">
              <div class="table-responsive">
                <table mat-table [dataSource]="dataSourceAttended" matSort class="table table-striped table-bordered table-hover" matTableResponsive matSortActive="eventId" matSortDirection="asc" matSortDisableClear>
                  <ng-container matColumnDef="Sr.No">
                    <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
                    <td mat-cell *matCellDef="let el"> {{el.rowNum}} </td>
                  </ng-container>
                  <ng-container matColumnDef="eventId">
                    <th mat-header-cell *matHeaderCellDef>Event Id</th>
                    <td mat-cell *matCellDef="let el"> {{el.eventId}} </td>
                  </ng-container>
                  <ng-container matColumnDef="udyamRegistrationNumber">
                    <th mat-header-cell *matHeaderCellDef>Udyam Number</th>
                    <td mat-cell *matCellDef="let el"> {{el.udyamRegistrationNumber}} </td>
                  </ng-container>
                  <ng-container matColumnDef="enterpriseName">
                    <th mat-header-cell *matHeaderCellDef>Enterprise Name</th>
                    <td mat-cell *matCellDef="let el"> {{el.enterpriseName}} </td>
                  </ng-container>
                  <ng-container matColumnDef="participantName">
                    <th mat-header-cell *matHeaderCellDef>Participant Name</th>
                    <td mat-cell *matCellDef="let el"> {{el.participantName}} </td>
                  </ng-container>
                  <ng-container matColumnDef="registrationType">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let el"> {{el.registrationType}} </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedAttendedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedAttendedColumns;"></tr>
                  Row shown when there is no matching data.
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No data matching the filter</td>
                  </tr>
                </table>
              </div>
              <mat-paginator #paginator
                             class="demo-paginator"
                             (page)="onPageAttendedChange($event)"
                             [length]="attendedLength"
                             [pageSize]="attendedPageSize"
                             [showFirstLastButtons]="attendedShowFirstLastButtons"
                             [pageSizeOptions]="attendedPageSizeOptions"
                             [hidePageSize]="attendedHidePageSize"
                             [pageIndex]="attendedPageIndex"
                             aria-label="Select page">
              </mat-paginator>
            </div>
          </div>
          <div class="row">
            <div mat-dialog-actions class="action-buttons">
              <button mat-button mat-dialog-close (click)="onClosePopup()">Close</button>
            </div>
          </div>
        </div>
      </ng-template>

      <!--MSME Feedback Count List Grid-->
      <ng-template #feedbackPopup>
        <h1 mat-dialog-title>Participant Feedback</h1>
        <div mat-dialog-content>
          <div class="row mb-1">
            <div class="col-md-12">
              <div class="table-responsive">
                <table mat-table [dataSource]="dataSourceGradingFeedback" matSort class="table table-striped table-bordered table-hover" matTableResponsive matSortActive="eventId" matSortDirection="asc" matSortDisableClear>
                  <ng-container matColumnDef="Sr.No">
                    <th mat-header-cell *matHeaderCellDef>Sr.No</th>
                    <td mat-cell *matCellDef="let el"> {{el.rowNum}} </td>
                  </ng-container>
                  <ng-container matColumnDef="eventId">
                    <th mat-header-cell *matHeaderCellDef>Event Id</th>
                    <td mat-cell *matCellDef="let el">
                      <a class="text-primary no-underline" (click)="action(el.uniqueEventId)" style="cursor: pointer;">{{ el.eventId }}</a>
                    </td>
                    <!--<td mat-cell *matCellDef="let el"> {{el.eventId}} </td>-->
                  </ng-container>
                  <ng-container matColumnDef="eventName">
                    <th mat-header-cell *matHeaderCellDef>Event Name</th>
                    <td mat-cell *matCellDef="let el"> {{el.eventName}} </td>
                  </ng-container>
                  <ng-container matColumnDef="udyamNumber">
                    <th mat-header-cell *matHeaderCellDef>Udyam Number</th>
                    <td mat-cell *matCellDef="let el"> {{el.udyamNumber}} </td>
                  </ng-container>
                  <ng-container matColumnDef="enrollmentId">
                    <th mat-header-cell *matHeaderCellDef>Enrollment</th>
                    <td mat-cell *matCellDef="let el"> {{el.enrollmentId}} </td>
                  </ng-container>
                  <ng-container matColumnDef="enterpriseName">
                    <th mat-header-cell *matHeaderCellDef>Enterprise Name</th>
                    <td mat-cell *matCellDef="let el"> {{el.enterpriseName}} </td>
                  </ng-container>
                  <ng-container matColumnDef="participantName">
                    <th mat-header-cell *matHeaderCellDef>Participant Name</th>
                    <td mat-cell *matCellDef="let el"> {{el.participantName}} </td>
                  </ng-container>
                  <ng-container matColumnDef="registrationType">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let el"> {{el.registrationType}} </td>
                  </ng-container>
                  <ng-container matColumnDef="feedback">
                    <th mat-header-cell *matHeaderCellDef>Feedback</th>
                    <td mat-cell *matCellDef="let el" style="text-align: center; border-style: none; ">
                      <button class="btn btn-primary btn-sm me-2" (click)="SubmitFeedback(el.eventId,el.udyamNumber, el.uniqueEventId, el.enrollmentId)">
                        View
                      </button>
                    </td>
                    <td mat-cell *matCellDef="let el"> {{el.feedback}} </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedFeedbackColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedFeedbackColumns;"></tr>
                  Row shown when there is no matching data.
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No data matching the filter</td>
                  </tr>
                </table>
              </div>
              <mat-paginator #paginator
                             class="demo-paginator"
                             (page)="onPageFeedbackChange($event)"
                             [length]="feedbackLength"
                             [pageSize]="feedbackPageSize"
                             [showFirstLastButtons]="feedbackShowFirstLastButtons"
                             [pageSizeOptions]="feedbackPageSizeOptions"
                             [hidePageSize]="feedbackHidePageSize"
                             [pageIndex]="feedbackPageIndex"
                             aria-label="Select page">
              </mat-paginator>
            </div>
          </div>
          <div class="row">
            <div mat-dialog-actions class="action-buttons">
              <button mat-button mat-dialog-close (click)="onClosePopup()">Close</button>
            </div>
          </div>
        </div>
      </ng-template>
    </form>
  </div>
</div>
